export default "__VITE_ASSET__6H6Y1C5n__"